import { lazy } from "react";
const OurBlogs = lazy(() => import("./components/ourBlogs/OurBlogs"));

const Blogs = () => {
  return (
    <>
      <OurBlogs />
    </>
  );
};

export default Blogs;
